import Vue from "vue";

import RealityCheck from "./reality-check.vue";
import InfoPage from "./info-page.vue";
import Stats from "./stats/stats.vue";
import DataSourcesPopup from "../common-components/data-sources-popup.vue";
import EmbeddableOverviewMap from "./embeddable-overview-map.vue";
import HistoryMap from "./history/history-map.vue";
import DateTracker from "./history/history-date-tracker.vue"


Vue.prototype.mparc = window.mparc;


if (document.getElementById("realityCheck")) {
    new Vue({
        el: '#realityCheck',
        components: {
            RealityCheck
        }
    });
}


if (document.getElementById("realityCheckStats")) {
    new Vue({
        el: '#realityCheckStats',
        components: {
            Stats, DataSourcesPopup
        }
    });
}


if (document.getElementById("realityCheckHistory")) {
    new Vue({
        el: '#realityCheckHistory',
        components: {
            HistoryMap, DateTracker
        },
        data: {
            activeYear: undefined,
            yearState: {},
            allYears: []
        },
        methods: {
            updateYearStates: function (obs) {
                // note: all target elements have the year/equiv as id

                obs.forEach(function (el) {
                    this.yearState[el.target.id] = el.isIntersecting;

                    // make the allYears array, assumes things arrive in order...
                    if (!this.allYears.includes(el.target.id)) {
                        this.allYears.push(el.target.id)
                    }
                }.bind(this))

                // now figure out which one to mark as active
                let activeYears = this.allYears.filter(function (el) {
                    if (this.yearState[el]) {
                        return el
                    }
                }.bind(this))

                // only update if there's something to update to (i.e. a long section might not have any targets visible)
                let visibleTargets = []
                Object.keys(this.yearState).forEach(function (year) {
                    if (this.yearState[year]) {
                        visibleTargets.push(year)
                    }
                }.bind(this));
                if (visibleTargets.length > 0) {
                    this.activeYear = activeYears[0]
                }
            }
        },
        computed: {},
        watch: {},
        mounted: function () {
            const observer = new IntersectionObserver(this.updateYearStates, {
                threshold: 1.0,
                rootMargin: "60px 0px 0px 0px"
            })
            document.querySelectorAll(".history-hidden-section-header").forEach(function (el) {
                observer.observe(el)
            });
        }
    });
}


if (document.getElementById("RealityCheckInfo")) {
    new Vue({
        el: '#RealityCheckInfo',
        components: {
            InfoPage
        }
    });
}


if (document.getElementById("embed-overview-map-container")) {
    new Vue({
        el: "#embed-overview-map-container",
        name: "embed_overview_map",
        components: {
             EmbeddableOverviewMap, DataSourcesPopup
        },
        data: {
        },
        methods: {
        },
        computed: {
        },
        mounted: function () {
        }
    });
}
